import { render, staticRenderFns } from "./TokenInfos.vue?vue&type=template&id=694916ce&scoped=true&"
import script from "./TokenInfos.vue?vue&type=script&lang=js&"
export * from "./TokenInfos.vue?vue&type=script&lang=js&"
import style0 from "./TokenInfos.vue?vue&type=style&index=0&id=694916ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694916ce",
  null
  
)

export default component.exports